import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import WapiService from 'wanderu-service-wapi';

import {
    MIX_TRIP_CARRIER_CODE,
} from '../../../constants';
import {
    actions as policiesActions,
} from '../../appstate';
import {
    fetchAllPoliciesAction,
} from '../fetchAllPolicies';
import {
    namespace,
    actions,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-ducks-carriers:fetchPolicy');

function fetchPolicy(carrierCode) {
    return async (dispatch, getState) => {
        let error;

        if (carrierCode === MIX_TRIP_CARRIER_CODE) {
            return undefined;
        }

        const allPoliciesFetching = fetchAllPoliciesAction.selectWorking(getState());
        const allPoliciesHasFetched = fetchAllPoliciesAction.selectSuccess(getState());
        if (allPoliciesFetching || allPoliciesHasFetched) {
            return undefined;
        }

        const hasFetched = selectors.selectSuccess(getState(), carrierCode);
        const isFetching = selectors.selectWorking(getState(), carrierCode);
        if (hasFetched || isFetching) {
            return undefined;
        }

        dispatch(actions.startWork(carrierCode));

        try {
            const response = await WapiService.get(`carriers/policies.json/${carrierCode}`);

            if (!response?.result) {
                throw new Error('no policy found');
            }

            return dispatch(policiesActions.setPolicy(carrierCode, response.result));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.warn('fetchPolicy', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                message: ex.message,
            };
        } finally {
            dispatch(actions.endWork(carrierCode, undefined, error));
        }

        return undefined;
    };
}

function setSuccess(carrierCode, meta) {
    return actions.endWork(carrierCode, meta);
}

const fetchPolicyAction = {
    fetchPolicy,
    setSuccess,
    ...selectors,
};

export {
    fetchPolicyAction,
};

export default {
    [namespace]: reducer,
};
